import React from 'react';
import ParserInput from "../../../react/components/ui/parserInput";
import { MovingTroopsParser } from "../../../travian/parser/rallyPoint";
import IncomingAttackList from "../../../react/components/travian/ingameData/incomingAttacks/list";
import {useLoaderData} from "react-router-dom";
import translate from "../../../translate";
import GroupPrivacyWarning from "../../../react/components/ui/common/groupPrivacyWarning";

function parsedDataHandler([ rallyPointData ]) {

}

export default function ToolTrav22() {
    /** @type object */
    const data = useLoaderData();

    return <div>
        <ParserInput parsedDataHandler={parsedDataHandler} domParsers={[MovingTroopsParser]} />

        <div className={'mt-2'}>
            <IncomingAttackList data={Object.values(data)} />
        </div>

        <div className={'mt-2'}>
            <GroupPrivacyWarning>{translate('tool/trav/22/warn_group_insight')}</GroupPrivacyWarning>
        </div>
    </div>
}
